export const EXTERNAL_LINKS = {
  // Social Media
  INSTAGRAM: 'https://www.instagram.com/travelwithxplorius/',
  TIKTOK: 'https://www.tiktok.com/@TRAVELWITHXPLORIUS',

  // Contact
  WHATSAPP: 'https://wa.me/message/6GFBB37QHD6UN1',
  EMAIL: 'mailto:hi@xplorius.com',

  // Founder
  FOUNDER_INSTAGRAM: 'https://www.instagram.com/ninakovalenko/',
}
